// extracted by mini-css-extract-plugin
export var closeButton = "_m7-2";
export var closeButtonIcon = "_m7-3";
export var lightboxContent = "_m7-1";
export var lightboxOverlay = "_m7-0";